import { Link, Body, Box, BoxProps } from '@hover/blueprint';
import React from 'react';
import { IPricingTableHeader } from '../../../interfaces/IPricingTableHeader';
import ArrowLink from '../../ui/ArrowLink';

interface Props extends BoxProps {
  card: IPricingTableHeader;
  onLinkClick?: () => void;
}

const HeaderCard: React.FC<Props> = ({ card, onLinkClick, ...restProps }) => (
  <Box
    h={{ base: '160px', desktop: '170px' }}
    bg={card.background}
    borderRadius="8px"
    borderBottomRadius={0}
    shadow="distance300"
    py={400}
    alignItems="center"
    flexDir="column"
    px="10px"
    {...restProps}
  >
    <Body
      size={{ base: 500, tablet: 600 }}
      fontWeight={700}
      textAlign="center"
      mb={100}
    >
      {card.name}
    </Body>
    <Body mb={200} textAlign="center" size={300} fontWeight={400}>
      {card.description}
    </Body>
    <ArrowLink
      d={{ base: 'none', tablet: 'flex' }}
      justifyContent="center"
      isMinimal
      mt="auto"
      w="100%"
      as={card.linkTo ? Link : 'button'}
      href={card.linkTo ? card.linkTo : undefined}
      onClick={card.linkTo ? () => {} : onLinkClick}
      isExternal={!!card.isExternal}
    >
      {card.buttonText}
    </ArrowLink>
    {card.linkTo ? (
      <Body
        d={{ base: 'block', tablet: 'none' }}
        mt="auto"
        isSemiBold
        color="primary.600"
        as={Link}
        href={card.linkTo}
        isExternal={!!card.isExternal}
      >
        {card.buttonText}
      </Body>
    ) : (
      <Body
        d={{ base: 'block', tablet: 'none' }}
        mt="auto"
        isSemiBold
        color="primary.600"
        as="button"
        onClick={onLinkClick}
      >
        {card.buttonText}
      </Body>
    )}
  </Box>
);

export default HeaderCard;
